import { NoSymbolIcon as BanIcon } from "@heroicons/react/24/outline";
import React, { useEffect } from "react";
import { useQueryClient } from "react-query";
import {
  ConfirmDialogActions,
  useConfirmationDialog,
} from "../shared-components/ConfirmationDialog";
import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import { useCancelMisconduct } from "../api/Cancel";
import { useFamaFlags } from "../api/FamaFlags";

type Props = {
  reportUUID: string;
};

const MisconductCancelButton = ({ reportUUID }: Props) => {
  const queryClient = useQueryClient();
  const { v3UiReactsToWebsocketWorkflowEvents: workflowEventsEnabled } =
    useFamaFlags();
  const {
    mutate: cancelMisconduct,
    error: cancelError,
    reset,
  } = useCancelMisconduct();
  const { modal, show, hide } = useConfirmationDialog();
  const canCancel = true; // TODO: check for the validation once available
  function handleCancel(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();

    if (!reportUUID) {
      show(
        "Wrong Report UUID",
        "",
        () => {},
        <>The report is in an invalid state</>,
        false
      );
    }

    show(
      "Report Cancel",
      "Are you sure you want to cancel the report?",
      (action: ConfirmDialogActions) => {
        if (action === "close") {
          hide();
          return;
        }

        cancelMisconduct([reportUUID], {
          onSuccess: () => {
            if (!workflowEventsEnabled) {
              queryClient.invalidateQueries({ queryKey: ["reportsInProcess"] });
            }
            hide();
          },
        });
      }
    );
  }

  useEffect(() => {
    if (cancelError) {
      show(
        "Error Canceling the report:",
        "",
        () => {},
        <div className="my-2">
          <ErrorMessageContainer>
            <>
              <strong className="block py-1">{reportUUID}</strong>
              Please try again or contact the administrator.
            </>
          </ErrorMessageContainer>
        </div>,
        false
      );
      reset();
    }
  }, [cancelError, reportUUID, reset, show]);

  return (
    <>
      {canCancel ? (
        <>
          <Button
            text="Cancel"
            className="cancel-report-button"
            colorType={ButtonColorTypes.cancel}
            onClick={handleCancel}
          />
          {modal}
        </>
      ) : (
        <BanIcon className="w-4" />
      )}
    </>
  );
};

export default MisconductCancelButton;
